import { ActionTree } from 'vuex'
import { RootState } from '@/store/types'
import { SettingsState, GroupedPreferences } from '@/store/settings/types'
import {
    SETTINGS_LOAD_PREFERENCES,
    SETTINGS_UPDATE_PREFERENCE,
    SETTINGS_BULK_SET_PREFERENCES,
    SETTINGS_SET_PREFERENCE
} from '@/store/settings/constants'
import SettingsAPI from '@/util/api/SettingsAPI'
import { Dictionary } from '@/types/general'
import { isAPIResponse } from '@/typecheck'

const actions: ActionTree<SettingsState, RootState> = {
    /**
     * Load all user preferences
     */
    async [SETTINGS_LOAD_PREFERENCES]({ commit }): Promise<void> {
        const unstructured = await SettingsAPI.getPreferences()

        const structured = unstructured.reduce((prev, { type, key, value }) => {
            if (!prev[type]) {
                prev[type] = {}
            }
            prev[type][key] = value
            return prev
        }, {} as Dictionary<GroupedPreferences>)

        commit(SETTINGS_BULK_SET_PREFERENCES, structured)
    },

    async [SETTINGS_UPDATE_PREFERENCE](
        { commit, state, getters },
        { type, key, value }
    ): Promise<boolean> {
        const prev = getters.preference(type, key)

        if (value === prev) {
            return false
        }

        commit(SETTINGS_SET_PREFERENCE, { type, key, value })

        const result = await SettingsAPI.updatePreference(type, key, value)

        if (isAPIResponse(result)) {
            commit(SETTINGS_SET_PREFERENCE, { type, key, value: prev })
            throw new Error(result.message)
        }

        return true
    }
}

export default actions
